import '../../assets/value.css';
import { jsx as o } from "react/jsx-runtime";
import m from "clsx";
import { forwardRef as p } from "react";
import { useComboboxContext as n } from "../../hooks/use-combobox-context.js";
const d = "_value_1qoc0_1", i = "_placeholder_1qoc0_17", e = {
  value: d,
  placeholder: i
}, h = p((l, r) => {
  const { children: a, className: c, ...s } = l, { placeholder: t } = n();
  return /* @__PURE__ */ o("div", { ...s, ref: r, className: m(e.value, c), children: a ?? /* @__PURE__ */ o("span", { className: e.placeholder, children: t }) });
});
h.displayName = "Combobox.Trigger.Value";
export {
  h as Value
};
